import React from 'react';
import logo from '../logo.svg';
import { GiCricketBat } from 'react-icons/gi';

function Header() {
  return (
    <div className='bg-red-900'>
      <div className='flex flex-row justify-between items-center p-3 lg:p-10'>
        <GiCricketBat className='text-5xl text-white' />
        {/* <img src={logo} alt='' className='w-10 h-10' /> */}
        <div className='flex flex-col items-end space-y-2'>
          <p className='text-5xl font-bold text-white rounded-lg px-2 py-1'>
            Digital Club Sport
          </p>
          <p className='text-gray-50 font-semibold'>
            Transforming the way technology is used in sport
          </p>
        </div>
      </div>
    </div>
  );
}

export default Header;
